/** Platform-wide Meta Messenger app credentials (Vercel env — one app for all orgs/projects). */

export type MessengerPlatformCredentials = {
  appId: string;
  appSecret: string;
  webhookVerifyToken: string;
};

export function getMessengerPlatformCredentials(): MessengerPlatformCredentials {
  return {
    appId: process.env.MESSENGER_APP_ID?.trim() ?? "",
    appSecret: process.env.MESSENGER_APP_SECRET?.trim() ?? "",
    webhookVerifyToken: process.env.MESSENGER_WEBHOOK_VERIFY_TOKEN?.trim() ?? "",
  };
}

export function isMessengerPlatformConfigured(): boolean {
  const { appId, appSecret, webhookVerifyToken } = getMessengerPlatformCredentials();
  return !!(appId && appSecret && webhookVerifyToken);
}

export function getMessengerWebhookUrl(): string {
  const baseUrl =
    process.env.NEXT_PUBLIC_APP_URL?.trim().replace(/\/$/, "") ??
    "https://app.easygpt.builders";
  return `${baseUrl}/api/messenger/webhook`;
}

export type MessengerProjectCredentials = {
  messengerPageId?: string | null;
  messengerPageAccessToken?: string | null;
};

export function isMessengerProjectConfigured(
  visualSettings?: MessengerProjectCredentials | null,
): boolean {
  const pageId = visualSettings?.messengerPageId?.trim();
  const token = visualSettings?.messengerPageAccessToken?.trim();
  return !!(pageId && token);
}

export function isMessengerFullyConfigured(
  visualSettings?: MessengerProjectCredentials | null,
): boolean {
  return isMessengerPlatformConfigured() && isMessengerProjectConfigured(visualSettings);
}
